/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Row,
  Col,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { routerActions } from 'react-router-redux';
import Toolbar from 'loracoms/Toolbar';
import Nvl from 'loracoms/Nvl';
import IntlMsg from 'lorautils/intl/IntlMsg';
import appActions from 'loraactions/app';
import dashboardActions from 'loraactions/dashboard';
import Chart from '../Chart';

const propTypes = {
  pushState: PropTypes.func.isRequired,
  getDashboard: PropTypes.func.isRequired,
  getApp: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  appState: PropTypes.object.isRequired,
  dashboardState: PropTypes.object.isRequired,
  dps: PropTypes.string.isRequired,
  dashId: PropTypes.string.isRequired,
  appId: PropTypes.string.isRequired,
};

class ChartDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appState: props.appState,
      dashboardState: props.dashboardState,
      dps: props.dps,
      dpsNew: [],
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.dashboard');
  }

  componentWillMount() {
    const { dashboardState: { data }, appState, dps } = this.state;
    const dpsNew = _.split(dps, ',');
    this.setState({ dps: dpsNew });
    const { getDashboard, dashId, appId, getApp } = this.props;
    if (!data) {
      getDashboard(dashId);
    }
    if (!appState.data) {
      getApp(appId);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { appState, dashboardState } = nextProps;
    if (appState !== this.props.appState) {
      this.setState({ appState });
    }
    if (dashboardState !== this.props.dashboardState) {
      this.setState({ dashboardState });
    }
  }

  render() {
    const { pushState, dashId, appId } = this.props;
    const { appState: { status, data }, dashboardState, dps } = this.state;
    let dpsNew = [];
    if (_.isArray(dps)) {
      dpsNew = dps;
    } else {
      dpsNew = [dps];
    }
    if (dashboardState.data && data) {
      const breadcrumb = [{
        content: this.intlMsg.globalMsg('application.breadcrumb.application'),
        onClick: () => pushState('/application'),
      }, {
        content: <Nvl status={status} val={data.name} />,
        onClick: () => pushState(`/application/${data.id}`),
      }, {
        content: <Nvl
          status={dashboardState.status}
          val={dashboardState.data.name.length === 0 ?
            dashboardState.data.id : dashboardState.data.name}
        />,
        onClick: () => pushState(`/application/${data.id}/dashboard/basic/${dashboardState.data.id}`),
      },
      ];
      return (
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Toolbar breadcrumb={breadcrumb} />
            </Col>
          </Row>
          <Chart
            dps={dpsNew}
            dpsShow={[{ data: dpsNew }]}
            // gridTop={30}
            dashId={dashId}
            appId={appId}
          />
        </Grid>
      );
    }
    return null;
  }
}

const mapStateToProps = (state, ownProps) => ({
  appState: state.app.getApp,
  time: state.dashboard.getTimes,
  dashboardState: state.dashboard.getDashboard,
  dps: ownProps.params.dps,
  dashId: ownProps.params.dashid,
  appId: ownProps.params.id,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  getDashboard: dashboardActions.getDashboard,
  getApp: appActions.getApp,
};

ChartDetail.propTypes = propTypes;

export default connect(mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ChartDetail,
));





// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/coms/ChartDetail/index.jsx